export const USER_EVENT_TYPE_RESERVATIONS = "reservations";
export const USER_EVENT_TYPE_PHOTO_ALBUM = "photo_album";
export const USER_EVENT_MAX_DURATION_DAYS = 7;
export const USER_PHOTO_ALBUM_DOWNLOAD_DEADLINE_DAYS = 30;

export const USER_EVENT_THEME_COLORS = [
    {key: "indigo", label: "Indigo", value: "#6d45f6"},
    {key: "rose", label: "Rose", value: "#ec2474"},
    {key: "emerald", label: "Emerald", value: "#55bd8c"},
    {key: "amber", label: "Amber", value: "#fb8700"},
    {key: "sky", label: "Sky", value: "#4aa7df"},
    {key: "berry", label: "Berry", value: "#9b4dca"},
];

export const USER_EVENT_THEME_FONTS = {
    "roboto": {
        label: "Roboto",
        import: "@import url('https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap');",
        property: "'Roboto', sans-serif !important",
    },
    "merriweather": {
        label: "Merriweather",
        import: "@import url('https://fonts.googleapis.com/css?family=Merriweather:400,700&display=swap');",
        property: "'Merriweather', serif !important",
    },
    "lemonada": {
        label: "Lemonada",
        import: "@import url('https://fonts.googleapis.com/css?family=Lemonada:400,700&display=swap');",
        property: "'Lemonada', cursive !important",
    },
    "poppins": {
        label: "Poppins",
        import: "@import url('https://fonts.googleapis.com/css?family=Poppins:400,700&display=swap');",
        property: "'Poppins', sans-serif !important",
    },
    "pt-serif": {
        label: "PT Serif",
        import: "@import url('https://fonts.googleapis.com/css?family=PT+Serif:400,700&display=swap');",
        property: "'PT Serif', serif !important",
    },
    "baloo-2": {
        label: "Baloo 2",
        import: "@import url('https://fonts.googleapis.com/css?family=Baloo+2:400,700&display=swap');",
        property: "'Baloo 2', cursive !important",
    },
    "caveat": {
        label: "Caveat",
        import: "@import url('https://fonts.googleapis.com/css?family=Caveat:400,700&display=swap');",
        property: "'Caveat', cursive !important",
    },
    "josefin-sans": {
        label: "Josefin Sans",
        import: "@import url('https://fonts.googleapis.com/css?family=Josefin+Sans:400,700&display=swap');",
        property: "'Josefin Sans', sans-serif !important",
    },
    "lobster-two": {
        label: "Lobster Two",
        import: "@import url('https://fonts.googleapis.com/css?family=Lobster+Two:400,700&display=swap');",
        property: "'Lobster Two', cursive !important",
    },
    "lora": {
        label: "Lora",
        import: "@import url('https://fonts.googleapis.com/css?family=Lora:400,700&display=swap');",
        property: "'Lora', serif !important",
    },
    "dancing-script": {
        label: "Dancing Script",
        import: "@import url('https://fonts.googleapis.com/css?family=Dancing+Script:400,700&display=swap');",
        property: "'Dancing Script', cursive !important",
    },
};
